<template>
  <Card>
    <div class="column">
      <div class="cardTitle">{{ $t('Ссылка на договор') }}</div>
      <div class="agreement">
        <a v-if="isValidUrl" :href="agreement" target="_blank" rel="noopener noreferrer">
          {{ agreement }}
        </a>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from "@intec/vue-components/form/Card.vue";

export default {
  name: 'AgreementInfo',
  components: {Card},
  props: {
    agreement: {
      type: String,
    },
  },
  computed: {
    isValidUrl() {
      try {
        return Boolean(new URL(this.agreement));
      } catch (e) {
        return false;
      }
    },
  },
};
</script>
<style scoped>
.agreement a {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: rgb(var(--primary-color));
  text-decoration: none;
}

.agreement a:hover {
  text-decoration: underline;
}

.agreement {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: rgb(var(--primary-color));
}

.column {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 15px;
}
</style>
